import * as React from 'react';

import { TPlaceType } from '../../../../../../types/calltracking';
import { CallButtonContainer } from '../../../../../CallButton';
import { EmptyField, CallField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

interface ICallButtonFieldContainerProps {
  placeType: TPlaceType;
}

export const CallButtonFieldContainer: React.VFC<ICallButtonFieldContainerProps> = ({ placeType }) => {
  const {
    contacts: { formattedPhone },
  } = useOfferContext();

  if (formattedPhone && formattedPhone.length > 0) {
    return (
      <CallField>
        <CallButtonContainer placeType={placeType} action="Open_compare_listing" />
      </CallField>
    );
  }

  return <EmptyField />;
};
